var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: {
        bottom: "",
        color: "lightSecondary lighten-4",
        "max-width": "300",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _vm.iso
                ? _c(
                    "div",
                    _vm._g(
                      {
                        staticClass: "d-flex align-center",
                        class: _vm.className,
                      },
                      on
                    ),
                    [
                      !_vm.size && _vm.showCountryFlag(_vm.iso)
                        ? _c("country-flag", {
                            staticClass: "elevation-3",
                            style: { transform: `scale(${_vm.scale})` },
                            attrs: { country: _vm.iso },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.size && _vm.showCountryFlag(_vm.iso)
                        ? _c("country-flag", {
                            staticClass: "elevation-3",
                            attrs: { country: _vm.iso, size: _vm.size },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.iso === "latam"
                        ? _c("img", {
                            attrs: {
                              height: "14",
                              src: "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/1160.png",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.iso === "caf"
                        ? _c("img", {
                            attrs: {
                              height: "14",
                              src: "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/1094.png",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.iso === "int"
                        ? _c("img", {
                            attrs: {
                              height: "14",
                              src: "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/326.png",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.iso === "eu"
                        ? _c("img", {
                            attrs: {
                              height: "14",
                              src: "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/327.png",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.iso === "afc"
                        ? _c("img", {
                            attrs: {
                              height: "14",
                              src: "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/1163.png",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.iso === "concacaf"
                        ? _c("img", {
                            attrs: {
                              height: "14",
                              src: "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/1154.png",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.iso
        ? _c("span", { staticClass: "black--text body-1" }, [
            _vm._v(_vm._s(_vm.$t(`iso.${_vm.iso.toUpperCase()}`))),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }